/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createAccount.defs.js'
export { main as default } from './createAccount.defs.js'
